import { Button } from "@mui/material";
import { useState, useEffect } from "react";
import useDelete from "../hooks/useDelete";
import colorConfigs from "../config/colorConfigs";
import { PleasewaitPopup } from "./PleasewaitPopup";

const DeletePopup = () => {
    const { deletePopup, setDeletePopup, data }: any = useDelete();
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    useEffect(() => {
        if (deletePopup) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deletePopup]);

    const closeModal = () => setDeletePopup(false);

    const deleteTheModal = () => {
        if (!pleaseWaitPopup) {
            setDeletePopup(false);
            setPleaseWaitPopup(true);
            data?.isDelete(() => {
                setPleaseWaitPopup(false);
            });
        }
    };


    return (
        <div className={`fixed inset-0 flex justify-center items-center z-[9999] ${deletePopup ? "flex" : "hidden"} bg-black bg-opacity-50 w-screen h-screen`}>
            <div className={`w-full max-w-lg bg-white shadow-lg rounded-2xl p-5 relative translate-y-[-70%]`}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320.591 320.591"
                    className={`w-3 cursor-pointer float-right`}
                    onClick={closeModal}
                >
                    <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                    <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                </svg>

                <div className="my-8 text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-12 fill-gray-400 inline" viewBox="0 0 24 24">
                        <path d="M19 7a1 1 0 0 0-1 1v11.191A1.92 1.92 0 0 1 15.99 21H8.01A1.92 1.92 0 0 1 6 19.191V8a1 1 0 0 0-2 0v11.191A3.918 3.918 0 0 0 8.01 23h7.98A3.918 3.918 0 0 0 20 19.191V8a1 1 0 0 0-1-1Zm1-3h-4V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2ZM10 4V3h4v1Z" />
                        <path d="M11 17v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Zm4 0v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Z" />
                    </svg>
                    <h4 className={`text-base font-semibold mt-4 text-gray-700`}>
                        {data?.tilte}
                    </h4>
                    <h4 className={`text-base font-semibold mt-4 text-gray-700`}>
                        {data?.summary}
                    </h4>

                </div>

                <div className="text-center flex justify-center gap-4">
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: colorConfigs.btn.cancel.bg,
                            border: colorConfigs.btn.cancel.border,
                            color: colorConfigs.btn.cancel.color
                        }}
                        onClick={closeModal}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: colorConfigs.btn.delete.bg
                        }}
                        onClick={deleteTheModal}
                    >
                        Yes
                    </Button>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </div>

    );
};

export default DeletePopup;